__turbopack_context__.v({
  "endOfFeed": "TopicArticlesList-module-scss-module__mclzwq__endOfFeed",
  "firstArticle": "TopicArticlesList-module-scss-module__mclzwq__firstArticle",
  "separator": "TopicArticlesList-module-scss-module__mclzwq__separator",
  "topicArticleContainer": "TopicArticlesList-module-scss-module__mclzwq__topicArticleContainer",
});
